<template>
    <div class="sync-action">
        <button 
            :disabled="rowData.id === 1"
            type="button"
            class="btn btn-default btn-sm"
            aria-label="Sinhorniziraj / uvozi"
            @click.prevent="isRunning">
            <i 
                :class="rowData.id === 1 ? 'text-default' : 'text-green'" 
                class="fa fa-refresh" 
                aria-hidden="true"/>
        </button>
    </div>
</template>

<script>
import VuejsDialog from 'vuejs-dialog';

Vue.use(VuejsDialog);

export default {
    name: 'SyncAction',

    props: {
        rowData:  {
            type:     Object,
            required: true
        },
        rowIndex: {
            type:    Number,
            default: 0
        }
    },

    methods: {
        isRunning() {
            axios.get(`/ajax/sources/${this.rowData.id}/sync`)
                .then(() => this.sync())
                .catch(() => this.wait());
        },

        sync() {
            this.$dialog.confirm(
                `<h4>Ali ste prepričani, da hočete sinhronizirati vir?</h4>
                    <p>Izvajanje zna trajati <b>dlje časa</b>!</p>`,
                {
                    html:       true,
                    okText:     'Da',
                    cancelText: 'Ne',
                })
                .then(() => {
                    this.$events.fire('sync', this.rowData);
                })
                .catch(() => {
                    // Nothing
                });
        },

        wait() {
            this.$dialog.confirm(
                `<h4>Proces se izvaja oz. je v čakalni vrsti za obdelavo</h4>
                    <p>Prosimo počakajte...</p>`,
                {
                    html:       true,
                    okText:     'Razumem',
                    cancelText: 'Zapri',
                })
                .then(() => {
                    // nothing
                })
                .catch(() => {
                    // Nothing
                });
        }
    }
};
</script>

<style>
    /* VueJS dialog */
    .dg-btn--ok {
        color: #fff;
        background-color: #00a65a;
        border-color: #008d4c;
    }

    .dg-btn--cancel {
        color: #fff;
        background-color: #dd4b39;
        border-color: #d73925;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Sources/SyncAction.vue